import { createContext } from 'react';
import { AdvertListContextType } from '#advertList/contexts/AdvertListContextType';

const AdvertListContext = createContext<AdvertListContextType>(null);

export { AdvertListContext };
